(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionSlider extends HTMLElement {
    constructor() {
      super();
      // DOMの準備ができたら初期化する
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
      } else {
        this.init();
      }
    }

    init() {
      this.swiperElement = this.querySelector('.swiper');
      if (!this.swiperElement || typeof Swiper === 'undefined') return;

      const nextButton = this.swiperElement.querySelector('.swiper-button-next');
      const prevButton = this.swiperElement.querySelector('.swiper-button-prev');

      const swiper = new Swiper(this.swiperElement, {
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 15,

        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false,

        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20,
            allowTouchMove: false,
          },
          990: {
            slidesPerView: 3.5,
            spaceBetween: 30,
            allowTouchMove: false,
          },
        },
      });
    }
  }
  customElements.define('featured-collection-slider', FeaturedCollectionSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-banner"] && !Shopify.designMode) return;
  try {
    
    class FloatingBanner extends HTMLElement {
        constructor() {
        super();
        this.banner = this.querySelector('.floating-banner');
        if (!this.banner) return;

        this.closeButton = this.querySelector('.floating-banner__close-button');
        const bannerClosed = sessionStorage.getItem('floatingBannerClosed');

        // セッション内でまだ閉じられていなければ表示
        if (bannerClosed !== 'true') {
            this.show();
        }

        this.closeButton.addEventListener('click', this.close.bind(this));
        }

        show() {
        this.banner.classList.add('is-visible');
        }

        close() {
        this.banner.classList.remove('is-visible');
        // セッションストレージに「閉じた」という情報を保存
        sessionStorage.setItem('floatingBannerClosed', 'true');
        }
    }
    customElements.define('floating-banner-section', FloatingBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-slide"] && !Shopify.designMode) return;
  try {
    
  class FvSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector('.swiper-fv-container');
      if (!this.swiperContainer || typeof Swiper === 'undefined') return;

      this.initSwiper();
    }

    initSwiper() {
      const swiper = new Swiper(this.swiperContainer, {
        effect: "fade",
        loop: true,
        speed: 2000,
        autoplay: { 
          delay: 4000, 
          disableOnInteraction: false 
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });
    }
  }
  customElements.define('fv-slider-section', FvSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"] && !Shopify.designMode) return;
  try {
    
    class CustomHeaderDrawer extends HTMLElement {
        constructor() {
        super();
        this.menuToggle = this.querySelector('summary');
        this.mainContent = document.getElementById('MainContent');
        this.menuDrawer = this.querySelector('.header-custom__menu-drawer');

        this.menuToggle.addEventListener('click', this.onToggleClick.bind(this));
        this.menuDrawer.addEventListener('click', this.onLinkClick.bind(this));
        }

        onToggleClick(event) {
        event.preventDefault();
        this.toggleMenu();
        }

        // メニューを開閉し、閉じた後に関数を実行する機能を追加
        toggleMenu(callback) {
        const isOpening = !this.menuToggle.parentElement.hasAttribute('open');
        this.menuToggle.setAttribute('aria-expanded', isOpening);
        document.body.classList.toggle('overflow-hidden', isOpening);
        this.menuToggle.parentElement.toggleAttribute('open', isOpening);
        this.mainContent.inert = isOpening;

        if (!isOpening && typeof callback === 'function') {
            // メニューが閉じるアニメーション(0.3s)より少し長く待つ
            setTimeout(callback, 350); 
        }
        }

        onLinkClick(event) {
        const link = event.target.closest('a');
        if (!link) return;

        // リンク先URLに # が含まれているかチェック
        if (link.href && link.href.includes('#')) {
            event.preventDefault(); // Shopifyの遷移を止める
            const targetUrl = link.href;

            // メニューを閉じる。閉じた後に関数としてページ遷移を実行
            this.toggleMenu(() => {
            window.location.href = targetUrl;
            });
        } else {
            // 通常のリンクは、メニューを閉じるだけ
            this.toggleMenu();
        }
        }
    }
    customElements.define('custom-header-drawer', CustomHeaderDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer_copy"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bk"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-parallax"] && !Shopify.designMode) return;
  try {
    
    class MediaParallaxSection extends HTMLElement {
        constructor() {
        super();
        }
    }
    customElements.define('media-parallax-section', MediaParallaxSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('newsletter-popup');
  const section = document.getElementById('newsletter-popup-section');
  
  // 要素が見つからない場合は処理を中断（購読済みでHTMLが出力されていない場合など）
  if (!popup || !section) return;

  const closeBtn = section.querySelector('.newsletter-popup__close');
  const overlay = section.querySelector('.newsletter-popup__overlay');
  const floatingBtn = document.getElementById('newsletter-floating-btn'); 

  const popupDelay = parseInt(section.dataset.delay) * 1000;
  const expireDays = parseInt(section.dataset.expireDays);
  const enableExpireLogic = section.dataset.enableExpire === 'true';
  const localStorageKey = 'shopify_newsletter_popup_closed';

  function showPopup() {
    popup.classList.add('is-visible');
  }

  function closePopup(recordHistory = true) {
    popup.classList.remove('is-visible');
    
    const isDesignMode = (window.Shopify && window.Shopify.designMode);
    const isLocalhost = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    
    if (isDesignMode || isLocalhost || !enableExpireLogic) {
      return; 
    }

    if (recordHistory) {
      const now = new Date();
      const item = {
        value: 'closed',
        expiry: now.getTime() + (expireDays * 24 * 60 * 60 * 1000)
      }
      localStorage.setItem(localStorageKey, JSON.stringify(item));
    }
  }

  function shouldShowPopup() {
    const isDesignMode = (window.Shopify && window.Shopify.designMode);
    const isLocalhost = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    if (isDesignMode || isLocalhost || !enableExpireLogic) {
      return true; 
    }

    const itemStr = localStorage.getItem(localStorageKey);
    if (!itemStr) return true;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(localStorageKey);
      return true;
    }
    return false;
  }

  if (shouldShowPopup()) {
    setTimeout(showPopup, popupDelay);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closePopup(true);
    });
  }
  if (overlay) {
    overlay.addEventListener('click', function() {
      closePopup(true);
    });
  }

  if (floatingBtn) {
    floatingBtn.addEventListener('click', function() {
      showPopup();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickup-grid"] && !Shopify.designMode) return;
  try {
    
    // このセクションはスライダーではないため、特別なJavaScriptは不要です。
    // 将来的な拡張性のためにカスタム要素の定義のみ残します。
    class PickupGrid extends HTMLElement {
        constructor() {
            super();
        }
    }
    customElements.define('pickup-grid-section', PickupGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      if (!this.dataset.url) return;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
    class RankingSlider extends HTMLElement {
        constructor() {
            super();
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this));
            } else {
                this.init();
            }
        }
        init() {
            this.swiperElement = this.querySelector('.swiper');
            if (!this.swiperElement || typeof Swiper === 'undefined') return;

            const swiper = new Swiper(this.swiperElement, {
                loop: false,
                slidesPerView: 1.5,
                spaceBetween: 15,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    750: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    990: {
                        slidesPerView: 3.5,
                        spaceBetween: 30,
                    },
                },
            });
        }
    }
    customElements.define('product-slider-section', RankingSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const readStorage = (key) => {
      try {
        return JSON.parse(localStorage.getItem(key) || '[]');
      } catch (error) {
        console.warn('Failed to parse recently viewed storage', error);
        return [];
      }
    };

    const writeStorage = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.warn('Failed to persist recently viewed storage', error);
      }
    };

    const normalizeHandles = (handles) => {
      if (!Array.isArray(handles)) return [];

      const clean = handles.filter((handle) => typeof handle === 'string' && handle.trim().length > 0);
      const unique = [];

      clean.forEach((handle) => {
        if (!unique.includes(handle)) {
          unique.push(handle);
        }
      });

      return unique;
    };

    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();

        const storageKey = this.dataset.storageKey || 'shopify-recently-viewed';
        const limit = Number.parseInt(this.dataset.limit || '4', 10);
        const sectionId = this.dataset.sectionId;
        const currentHandle = this.dataset.productHandle;
        const hideUnavailable = this.dataset.hideUnavailable === 'true';
        const container = this.querySelector('[data-recently-viewed-container]');
        const heading = this.querySelector('[data-recently-viewed-heading]');
        const list = this.querySelector('[data-recently-viewed-list]');

        if (!sectionId || !list) return;

        const stored = normalizeHandles(readStorage(storageKey));
        if (currentHandle) {
          const filtered = stored.filter((handle) => handle !== currentHandle);
          filtered.unshift(currentHandle);
          writeStorage(storageKey, filtered.slice(0, 20));
        } else {
          writeStorage(storageKey, stored.slice(0, 20));
        }

        const updated = normalizeHandles(readStorage(storageKey));
        const displayHandles = updated.filter((handle) => handle !== currentHandle).slice(0, limit);
        if (!displayHandles.length) {
          this.setAttribute('hidden', 'hidden');
          if (container) container.setAttribute('hidden', 'hidden');
          return;
        }

        const parser = new DOMParser();
        const requests = displayHandles.map((handle, index) =>
          fetch(`/products/${handle}?view=recently-viewed-card`)
            .then((response) => {
              if (!response.ok) throw new Error(`Failed to fetch card for ${handle}: ${response.status}`);
              return response.text();
            })
            .then((text) => {
              const doc = parser.parseFromString(text.trim(), 'text/html');
              const item = doc.body.firstElementChild;
              if (!item) return null;
              item.dataset.rank = (index + 1).toString();
              const available = item.dataset.productAvailable !== 'false';
              return { item, available, handle };
            })
            .catch((error) => {
              return null;
            })
        );

        Promise.all(requests).then((results) => {
          const fragment = document.createDocumentFragment();
          let appended = 0;

          results.forEach((result) => {
            if (!result) return;
            if (hideUnavailable && !result.available) return;
            fragment.appendChild(result.item);
            appended += 1;
          });

          if (!appended) {
            this.setAttribute('hidden', 'hidden');
            if (container) container.setAttribute('hidden', 'hidden');
            return;
          }

          list.appendChild(fragment);
          if (container) container.removeAttribute('hidden');
          if (heading) heading.removeAttribute('hidden');
          this.classList.add('product-recommendations--loaded');
          this.removeAttribute('hidden');
        });
      }
    }

    if (!customElements.get('recently-viewed-products')) {
      customElements.define('recently-viewed-products', RecentlyViewedProducts);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll('.tabbed-content__tab-button');
      this.tabPanels = this.querySelectorAll('.tabbed-content__panel');
      this.narrativeItems = this.querySelectorAll('.tabbed-content__narrative-item');
      this.narrativeWrapper = this.querySelector('.tabbed-content__narrative');
      this.contentWrapper = this.querySelector('.tabbed-content__content-bg');

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => this.onTabClick(button));
      });
    }

    onTabClick(clickedButton) {
      this.tabButtons.forEach((button) => button.setAttribute('aria-selected', 'false'));
      this.tabPanels.forEach((panel) => panel.setAttribute('hidden', 'true'));
      if (this.narrativeItems.length) {
        this.narrativeItems.forEach((item) => item.setAttribute('hidden', 'true'));
      }

      clickedButton.setAttribute('aria-selected', 'true');
      const targetPanelId = clickedButton.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetPanelId);
      if (targetPanel) {
        targetPanel.removeAttribute('hidden');
      }

      const hasNarrative = clickedButton.dataset.hasNarrative === 'true';
      const narrativeId = clickedButton.dataset.narrativeId;
      if (hasNarrative && narrativeId && this.narrativeItems.length) {
        const targetNarrative = document.getElementById(narrativeId);
        if (targetNarrative) {
          targetNarrative.removeAttribute('hidden');
          this.scrollToNarrative(targetNarrative);
        }
      } else {
        this.scrollToContent(targetPanel || this.contentWrapper);
      }
    }

    scrollToNarrative(targetNarrative) {
      if (!this.narrativeWrapper || !targetNarrative) {
        this.scrollToContent(this.contentWrapper);
        return;
      }

      this.scrollToElement(targetNarrative);
    }

    scrollToContent(targetElement) {
      if (!targetElement) return;
      this.scrollToElement(targetElement);
    }

    scrollToElement(targetElement) {
      if (!targetElement) return;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offset = 80;
      const scrollTarget = Math.max(targetPosition - offset, 0);

      window.scrollTo({
        top: scrollTarget,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }
  }
  customElements.define('tabbed-content-section', TabbedContent);

  } catch(e) { console.error(e); }
})();
})();
